<script setup>
  import { useLayout } from '@/layout/composables/layout'
  const { toggleDarkMode, isDarkTheme, getMode } = useLayout()

  if (!isDarkTheme.value && getMode.value) {
    toggleDarkMode()
  }
</script>

<template>
  <router-view />
</template>

<style scoped></style>
